export const appointmentEditReason = [
    "病人要求修改時間",
    "病人臨時取消預約",
    "醫師未能開診",
    "診所未能開診",
    "預約時間錯誤",
    "輪候時間太長",
    "病人不舒服",
] as const;